import { withPayload } from '../common'

export const UPDATE_INVITATION = 'UPDATE_INVITATION'
export const TOGGLE_INVITATION_CREATION = 'TOGGLE_INVITATION_CREATION'
export const START_INVITATION_CREATION = 'START_INVITATION_CREATION'

export const createInvitation = (invitation) => withPayload(START_INVITATION_CREATION, invitation)
export const toggleInvitationCreation = (type) => withPayload(TOGGLE_INVITATION_CREATION, type)
export const updateInvitation = (invitation) => withPayload(UPDATE_INVITATION, invitation)
